export const EXPERIMENTAL_DESIGN_SET_SIGNAL_TYPES = 'EXPERIMENTAL_DESIGN_SET_SIGNAL_TYPES';

export const SIGNAL_TYPES_TAG = 'SignalTypes';

/**
 * Sets the Signal Types
 * @param signalTypes
 * @returns {{type: string, signalTypes: *}}
 */
export const setSignalTypes = signalTypes => {
  return {
    type: EXPERIMENTAL_DESIGN_SET_SIGNAL_TYPES,
    signalTypes
  };
};

/**
 * Gets the various Signal Types with their dimensions, hardware, software & versions.
 */
export const getSignalTypes = () => {
  return async (dispatch, getState, { apiClient }) => {
    const results = await apiClient.call(SIGNAL_TYPES_TAG, 'getSignalTypes');
    dispatch(setSignalTypes(results.data));
    return true;
  };
};

export const EXPERIMENTAL_DESIGN_SET_TRANSFORMATIONS = 'EXPERIMENTAL_DESIGN_SET_TRANSFORMATIONS';

export const TRANSFORMATIONS_TAG = 'Transformations';

export const setTransformations = transformations => {
  return {
    type: EXPERIMENTAL_DESIGN_SET_TRANSFORMATIONS,
    transformations
  };
};

// TODO: TRansformations
export const getTransformations = () => {
  return async (dispatch, getState, { apiClient }) => {
    const results = await apiClient.call(SIGNAL_TYPES_TAG, 'getSignalTypes');
    dispatch(setTransformations(results.data));
    return true;
  };
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/experimentalDesign/staticDataActions.js